import { Stack, Typography, styled } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { AquariusBadge } from "@smartrr/shared/customerPortal/components/AquariusBadge";
import { AquariusButton } from "@smartrr/shared/customerPortal/components/AquariusButton";
import { ISmartrrBundlePacks } from "@smartrr/shared/entities/SellingPlanGroup";
import _ from "lodash";
import React from "react";

const Wrapper = styled(Stack)`
  display: flex;
  height: 100%;
  justify-content: center;
  max-width: 150px;
  text-align: center;

  & [class*="bundle-pack-button"] {
    display: flex;
    align-items: center;
    justify-content: end;
    height: 65px;
  }

  button {
    margin-top: 0px;
    max-width: 85px;
    min-width: 85px;
    width: 85px;
  }
`;

interface IPackBtnProps {
  pack: ISmartrrBundlePacks;
  activePack: ISmartrrBundlePacks | undefined;
  setActivePack: React.Dispatch<React.SetStateAction<ISmartrrBundlePacks | undefined>>;
}
export const PackBtn = ({ pack, setActivePack, activePack }: IPackBtnProps) => {
  const { description, alert, name } = pack;
  const isActivePack = activePack ? pack.buyWithVariant === activePack.buyWithVariant : false;

  return (
    <Wrapper className={prefixClassName("bundle-pack-wrapper")} spacing="5px" direction="column">
      <Stack
        className={prefixClassName("bundle-pack-button")}
        data-testid={prefixClassName("bundle-pack-button")}
        spacing="5px"
      >
        {alert.trim() ? <AquariusBadge label={alert} /> : null}
        <AquariusButton filled={isActivePack} onClick={() => (isActivePack ? null : setActivePack(pack))}>
          {name}
        </AquariusButton>
      </Stack>
      {!isActivePack && description ? (
        <Stack className={prefixClassName("bundle-pack-description")}>
          <Typography variant="caption1" sx={{ width: "100%", overflowWrap: "anywhere" }}>
            {_.truncate(description, { length: 75 })}
          </Typography>
        </Stack>
      ) : null}
    </Wrapper>
  );
};
